import { cn } from '@bem-react/classname';

export const cnKhStreamScreen = cn('KhStreamScreen');
